import { Switch } from '@mui/material'
import styled from 'styled-components'

const CustomSwitch = styled(Switch)(({ theme }) => ({}))

export default CustomSwitch
